import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Subscription, lastValueFrom } from 'rxjs';
import {
  ProjectItem,
  TransactionItem,
  TransactionTypeEnum,
  OutlineItem,
} from 'src/app/shared/models/base.models';
import { ApiService } from 'src/app/shared/services/api.service';
import { CreateTransactionDto } from './dto/create-transaction.dto';
import { ToastrService } from 'ngx-toastr';
import { TranslocoService } from '@jsverse/transloco';


@Component({
  selector: 'app-create-space-transaction-modal',
  templateUrl: './create-space-transaction-modal.component.html',
  styleUrls: ['./create-space-transaction-modal.component.css'],
})
export class CreateSpaceTransactionModalComponent implements OnInit, OnDestroy {


  transactionTypeEnum = TransactionTypeEnum
  currentTransactionType: TransactionTypeEnum = TransactionTypeEnum.income;



  form = new FormGroup({
    transactionType: new FormControl(TransactionTypeEnum.expense, [Validators.required])
  });
  model: any = {};
  fields: FormlyFieldConfig[] = [];
  @ViewChild('walletCreationModal') modalContent: TemplateRef<any>;
  @Input() modalRef: NgbModalRef;

  @Input() space: ProjectItem;
  @Input() wallet: OutlineItem;

  @Input('opener') set modalOpener(value: boolean) {
    if (!!value) {
      this.open();
    }
  }

  @Output() openerChange = new EventEmitter<boolean>();

  @Output() itemCreated = new EventEmitter<TransactionItem>();

  subscriptions: Subscription[] = []
  constructor(
    private api: ApiService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private translocoService: TranslocoService
  ) {}


  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  ngOnInit(): void {

  }

  initFormFields() {

    let currentDateTime = new Date()
    this.fields = [
      {
        key: 'contact_id',
        type: 'system-transaction-contact',
        props: {
          label: this.translocoService.translate('system.transaction_contact'),
          placeholder: this.translocoService.translate('system.placeholders.select_transaction_contact'),
          required: true,
          attributes: {
            space_id: this.space.id,
            category_type: this.currentTransactionType
          },
        },
        
        hideExpression: 'model.transactionType == "expense" || model.transactionType == "income"',
      },
      {

        key: 'category_id',
        type: 'system-transaction-category',
        props: {
          label:     this.translocoService.translate('system.transaction_category'),
          placeholder: this.translocoService.translate('system.placeholders.select_transaction_category'),
          required: true,
          min: 0,
          attributes: {
            space_id: this.space.id,
            category_type: this.currentTransactionType
          },
        },
        hideExpression: 'model.transactionType == "debt" || model.transactionType == "credit"',
      },
      {
        key: 'wallet_id',
        type: 'system-wallet',
        props: {
          label: this.translocoService.translate('system.transaction_wallet'),
          placeholder: this.translocoService.translate('system.placeholders.select_transaction_wallet'),
          required: true,
          min: 0,
          attributes: {
            space_id: this.space.id,
          },
        },
      },
      {
        key: 'amount',
        type: 'number',
        validators: [Validators.max(-1)],
        props: {
          attributes: {
            class: 'form-control form-control-solid form-control-lg',
          },
          label: this.translocoService.translate('system.amount'),
          placeholder: this.translocoService.translate('system.placeholders.enter_amount'),
          required: true,
          min: 0,
        },
      },
      {
        key: 'description',
        type: 'textarea',
        props: {
          attributes: {
            class: 'form-control form-control-solid form-control-lg h-100px',
          },
          label: this.translocoService.translate('system.description'),
          placeholder: this.translocoService.translate('system.placeholders.enter_description'),
          required: false,
        },
      },
      {
        key: 'transactionAt',
        type: 'system-transaction-date-time',
        props: {
          attributes: {
            class: 'form-control form-control-solid form-control-lg h-100px',
          },
          label: this.translocoService.translate('system.date_and_time'),
          placeholder: `(${currentDateTime.toLocaleString()}) (optional)`,
          required: false,
        },
      },
    ];

    this.subscriptions.push(this.form.controls.transactionType.valueChanges.subscribe(value=> {
      this.model = {...this.model, transactionType: value};
      switch (value) {
        case TransactionTypeEnum.debt:
          // this.changeCategoryFieldToContact();
          break;
          case TransactionTypeEnum.credit:
            // this.changeCategoryFieldToContact();
            break;
        default:
          break;
      }
    }));
    this.form.controls.transactionType.setValue(TransactionTypeEnum.expense)
  }


//   changeCategoryFieldToContact () {
//     this.fields.unshift({
//       key: 'contact_id',
//       type: 'text',
//       props: {
//         label: 'Contact',
//         placeholder: 'Select a contact',
//         required: true,
//         min: 0,
//         attributes: {
//           space_id: this.space.id,
//           category_type: this.currentTransactionType
//         },
//       },
//     });
//     console.log(this.fields)
// }


  async onSubmit(data) {
    console.log(data);
    this.form.markAllAsTouched();
    if (this.form.valid) {
      // Check if the form is valid
      let newTransactionPayload: CreateTransactionDto = {
        name: data.name,
        amount: data.amount,
        wallet_id: data.wallet_id,
        description: data.description,
        category_id: data.category_id,
        contact_id: data.contact_id,
        type: data.transactionType,
        transactionAt: data.transactionAt
      };
      let newTransaction = await this.createTransaction(
        this.space.id,
        newTransactionPayload
      );
      this.closeModal();
      this.itemCreated.emit(newTransaction);
    } else {
      this.toastr.error(
        this.translocoService.translate('system.fill_all_required_fields')
      );
    }
  }

  async createTransaction(
    spaceId: number = this.space.id,
    payload: CreateTransactionDto
  ) {
    let request$ = this.api.createTransaction(spaceId, payload);
    let response = await lastValueFrom(request$);

    console.log(response);
    return response;
  }
  resetEverything() {}

  closeModal() {
    this.modalRef.dismiss();
    this.openerChange.emit(false);
  }

  async onOpenModal() {
    this.initFormFields();
    this.resetEverything();
  }

  // Modal Open
  async open(content?) {
    this.onOpenModal();
    this.modalRef = this.modalService.open(this.modalContent, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      backdrop: 'static',
      centered: true,
      animation: true,
      windowClass: 'global-modal-class modal-animate-in',
    });
  }
}
